import { FC } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { Binoculars24 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';

const Wrapper = styled.div`
  background: ${colors.backgroundTertiary};
  border-radius: ${spacing.half};
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  padding: ${spacing.plusHalf};

  &[data-external='true'] {
    background: ${colors.backgroundSecondary};
  }
`;

const FlexHeading = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  justify-content: flex-start;
`;

export interface SummaryBannerLoadingProps {
  asExternalContent?: boolean;
}

export const SummaryBannerLoading: FC<SummaryBannerLoadingProps> = ({
  asExternalContent = false,
}) => {
  const textColor = asExternalContent ? colors.iconPrimary : colors.iconInteractive;
  return (
    <Wrapper data-external={asExternalContent}>
      <FlexHeading>
        <Binoculars24 color={textColor} />
        <Skeleton height={20} />
      </FlexHeading>
    </Wrapper>
  );
};
